import { useQuery } from '@apollo/client';
import {
  IDashboardConfigQuery,
  IDashboardConfigQueryVariables,
} from '../../../utils/apollo/graphqlSchema';
import { GET_DASHBOARD_CONFIG } from '../../../utils/apollo/dashboards';
import { useAppDispatch } from '../../../redux/hooks';
import { loadDashboardConfig } from '../../../redux/slices/dashboardConfig';
import useDashboardConfigSelector from '../../../redux/selectorHooks/useDashboardConfigSelector';

const useLoadDashboardConfig = () => {
  const dispatch = useAppDispatch();
  const dashboardConfigLoaded = useDashboardConfigSelector('isLoaded');

  const onLoadDashboardConfig = (data: IDashboardConfigQuery) => {
    dispatch(loadDashboardConfig(data.dashboardConfig));
  };

  // load config if not loaded
  useQuery<IDashboardConfigQuery, IDashboardConfigQueryVariables>(
    GET_DASHBOARD_CONFIG,
    {
      onCompleted: onLoadDashboardConfig,
      skip: dashboardConfigLoaded,
    },
  );

  return null;
};

export default useLoadDashboardConfig;
